export const Loading = () => {
    return (
        <div className="tw:fixed tw:top-0 tw:left-0 tw:w-full tw:h-[3px] tw:overflow-hidden tw:z-50 tw:bg-transparent">
            <div className="tw:h-full tw:w-1/3 tw:bg-linear-to-r tw:from-red-600 tw:via-amber-400 tw:to-yellow-500 tw:animate-css tw:animate-[flame_5.2s_ease-in-out_infinite] ">
                &nbsp;
            </div>
        </div>
    );
};
